let btnCheckout = document.querySelector('.cart__checkout')
priceMin = btnCheckout.dataset.minPrice

document.addEventListener('DOMContentLoaded',()=>{
    const metaTitle = document.querySelectorAll('.text--header')
    const metaText = document.querySelectorAll('.meta__text')
    const open = document.querySelectorAll('.open-dropdown')
    const close = document.querySelectorAll('.close-dropdown')
    let productSwatchColors = [...document.querySelectorAll('.color-swatch__product')]
    let colorSwatchBorders = document.querySelectorAll('.color-swatch__border')
    const btnContinueBuy = document.querySelector('.continue__buy')
    let swatchPositions = document.querySelectorAll('[data-swatch-position]')
    let cartPrimary = document.querySelector('[data-cart-primary]')
    let cartSecundary = document.querySelector('[data-cart-secundary]')
    let searchPrimary = document.querySelector('[data-search-primary]')
    let searchSecundary = document.querySelector('[data-search-secundary]')
    var collectionSlider = [...document.querySelectorAll('.collection-slider_container')];
    let btnMenuMobile = document.querySelector('[data-menu]')
    let menuSecundary = document.querySelector('.menu-secundary')
    let menuSecundaryClose = document.querySelector('.menu-secundary-close')

    btnMenuMobile.addEventListener('click', ()=>{
        menuSecundary.classList.toggle('menu-secundary-close-hide')
        menuSecundaryClose.classList.toggle('menu-secundary-close-hide')
        menuSecundaryClose.classList.toggle('menu-secundary-close-show')
    })

    let allBtnMenu = document.querySelectorAll('.mobile-nav__toggle')
    allBtnMenu.forEach(btnMenu => {
        btnMenu.addEventListener('click',()=>{
            btnMenu.parentElement.parentElement.classList.toggle('background__grey')
        })
    });
    
    collectionSlider.forEach(item => {
        var flktyCollectionSlider = new Flickity( item, {
        // options
            cellAlign: 'left',
            contain: true,
            groupCells: true
            
        });
    });

    if (screen.width < 550) {
        let collectionListSlider = document.querySelector('.collection--slider ')
        var flktyCollectionListSlider = new Flickity( collectionListSlider, {
            freeScroll: true,
            contain: true,
            // disable previous & next buttons and dots
            prevNextButtons: false,
            pageDots: false  ,
            autoPlay: 2000
        });
    }
    productSwatchColors.forEach((productSwatchColor, i) => {
        productSwatchColors[i].addEventListener('click', (evt)=>{
            evt.preventDefault()
            colorSwatchBorders.forEach((colorSwatchBorder, i)=>{
                colorSwatchBorders[i].classList.remove('add--border')
            })
            colorSwatchBorders[i].classList.add('add--border')
        })

    });
    btnContinueBuy.addEventListener('click', (evt)=>{
        evt.preventDefault()
        document.querySelector('.drawer__close-button').click()
    })
    swatchPositions.forEach(swatchPosition =>{        
        swatchPosition.addEventListener('click', (evt)=>{
            if ( evt.target.dataset.variantImage ){
                let positionSwatch = evt.target.dataset.swatchPosition
                let imageContainer = document.querySelector(`[data-image-card-position="${positionSwatch}"]`)
                let imageSrc = evt.target.dataset.variantImage            
                imageContainer.children[0].children[0].src = imageSrc             
            }
        })   
    })
    metaTitle.forEach((title , i ) => {
        metaTitle[i].addEventListener('click', (e)=>{
            const isOpen = metaText[i].classList.contains('meta__text--open')
            metaText[i].classList.toggle('meta__text--open');       
            metaText[i].style.height = `${isOpen ? 0 : metaText[i].children[0].scrollHeight + 35}px`
            metaText[i].parentElement.classList.toggle('background--container')
            open[i].classList.toggle('open-dropdown-close')
            close[i].classList.toggle('close-dropdown-open')
        })
    });

    cartSecundary.addEventListener('click', (evt)=>{ 
        cartPrimary.click()
        evt.preventDefault()
        evt.stopPropagation()
    })
    
    searchSecundary.addEventListener('click',(evt)=>{
        searchPrimary.click()
        evt.preventDefault()
        evt.stopPropagation()
    })

    if (screen.width < 768) {
        let allDatTypeFooter = document.querySelectorAll('[data-type]')
        allDatTypeFooter.forEach(dataTypeFooter => {
            if (dataTypeFooter.dataset.type === 'separator') {
                dataTypeFooter.style.display = 'none'
            }
        });     
    }
})

document.addEventListener('cart:updated',(evt)=>{
    let cartDetail = evt.detail.cart
    let cartItemCount = cartDetail.item_count
    let cartPrice = cartDetail.items_subtotal_price
    cartPrice = Math.round(cartPrice / 100)
    cartDetails(cartPrice, cartItemCount)
})

document.addEventListener('ajaxProduct:added', async (evt) =>{
    const cartData = await getCart();
    let cartItemCount = cartData.item_count
    let cartPrice = cartData.items_subtotal_price
    cartPrice = Math.round(cartPrice / 100)
    cartDetails(cartPrice, cartItemCount)
})

async function getCart(){
    const cart = await fetch('/cart.js')
    return await cart.json();
}


function cartDetails(cartPrice, cartItemCount){
    const allItemCount = document.querySelectorAll('.cart-link__bubble')
    allItemCount.forEach(itemCount => {
        itemCount.textContent = cartItemCount;
    });
    
    if (cartPrice >= priceMin) {
        btnCheckout.removeAttribute('disabled')
        btnCheckout.classList.remove('disable-checkout')
        return;  
    }
    btnCheckout.setAttribute('disabled','true')
    btnCheckout.classList.add('disable-checkout')
}